import { render, staticRenderFns } from "./tuzhuangliangtinghetong.vue?vue&type=template&id=ce6b2f38&scoped=true&"
import script from "./tuzhuangliangtinghetong.vue?vue&type=script&lang=js&"
export * from "./tuzhuangliangtinghetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6b2f38",
  null
  
)

export default component.exports